import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, signal } from '@angular/core';
import { environment } from '@env/environment';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipDirective } from 'shared/directives/tooltip.directive';
import { getCachedImage } from 'shared/util/get-cached-image';

@Component({
    selector: 'app-generic-logo-with-name-renderer',
    imports: [TranslatePipe, TooltipDirective],
    templateUrl: './generic-logo-with-name-renderer.component.html',
    styleUrl: './generic-logo-with-name-renderer.component.scss',
})
export class GenericLogoWithNameRendererComponent implements ICellRendererAngularComp {
    protected baseUrl = environment.BASE_URL.substring(0, environment.BASE_URL.length - 1); //Removed last forward slash
    readonly cachedLogoUrl = signal<string | null | undefined>(null);

    readonly displayValue = signal<string | null | undefined>(null);
    readonly logoUrl = signal<string | null | undefined>(null);

    readonly infoTooltipText = signal<string | null | undefined>(null);

    linkUrl: string | undefined;

    agInit(
        params: ICellRendererParams & {
            logoUrl?: string;
            displayName?: string;
            infoTooltipText?: string | Function;
        },
    ): void {
        this.displayValue.set(params.displayName ?? params.valueFormatted);

        if (typeof params.infoTooltipText === 'function') {
            this.infoTooltipText.set(params.infoTooltipText.call(this));
        } else {
            this.infoTooltipText.set(params.infoTooltipText);
        }

        this.logoUrl.set(params.logoUrl);
        if (this.logoUrl()) {
            getCachedImage(this.baseUrl + this.logoUrl()).then((data) => {
                this.cachedLogoUrl.set(data);
            });
        }
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }
}
